import { cookieService } from '@/services/cookie.service';
import { useEffect, useMemo } from 'react';

export const useGestureUnlock = (
	username: string,
	setInitUserName: (username: string) => void,
) => {
	const gestureUsersList = useMemo(() => {
		const gestureUsers = cookieService.getGestureUsers();
		return gestureUsers;
	}, []);

	const hadUsedGestureLogin = useMemo(() => {
		const lastestUser = cookieService.getUserNames()[0];
		const lastestGesture = cookieService.getGestureUsers()[0];
		return lastestUser && lastestGesture && lastestUser === lastestGesture;
	}, [gestureUsersList]);

	const siteconfigOpenGesture  = 1;

	const isGestureSwitchEnabled = useMemo(() => {
		// TODO 需補上siteconfig邏輯
		if (siteconfigOpenGesture !== 1) {
			return false;
		}
		if (gestureUsersList.includes(username?.toLowerCase())) {
			return true;
		}
	}, [username, gestureUsersList]);
	
	useEffect(() => {
		if (hadUsedGestureLogin && gestureUsersList.length > 0) {
			setInitUserName(gestureUsersList[0]);
		}
	}, [hadUsedGestureLogin, gestureUsersList]);
	
	return {
		isGestureSwitchEnabled,
		hadUsedGestureLogin,
		gestureUsersList
	};
};